import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/en-gb';
import { CALENDAR_WEEK_START_INDEX } from '@/constants/calendar';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: CALENDAR_WEEK_START_INDEX });
dayjs.updateLocale('en-gb', { weekStart: CALENDAR_WEEK_START_INDEX });
